import React, { useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import Modal from "react-bootstrap/Modal"
import { Link } from "react-router-dom"
import { motion as m } from "framer-motion"
import useFetchDocument from "../Componentslogic/Usefetchdocument"
import { GetonepickuporderHook } from "../Componentslogic/ReservationHook/getonepickuporder"

export const OneDeliveryorderdetails2 = () => {
  const { id } = useParams()
  const { document } = useFetchDocument("DeliveryOrders", id)
  const [handleDelete] = GetonepickuporderHook(id, document)
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const user = JSON.parse(localStorage.getItem("user"))

  const convertTo24HourFormat = (timeString) => {
    if (!timeString) return ""

    // If the time string is from Firestore (Date object)
    if (typeof timeString === "object" && timeString.seconds) {
      return new Date(timeString.seconds * 1000).toLocaleTimeString([], {
        hourCycle: "h23",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
    }

    // If the time is in 12-hour format (AM/PM), convert it
    const timeMatch = timeString.match(/(\d+):(\d+):(\d+)\s?(AM|PM)?/i)
    if (timeMatch) {
      let [_, hours, minutes, seconds, period] = timeMatch
      hours = parseInt(hours, 10)

      if (period) {
        if (period.toUpperCase() === "PM" && hours !== 12) hours += 12
        if (period.toUpperCase() === "AM" && hours === 12) hours = 0
      }

      return `${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`
    }

    return timeString // Return as-is if already in 24-hour format
  }

  return (
    <m.div
      className="p-4 all-details"
      initial={{ opacity: 0, x: 15 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
    >
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Confirm Delete </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete Order of{" "}
          <strong>{document?.userName}</strong> on table :{" "}
          <strong>{document?.ordernumber}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={(e) => handleDelete(e, document.id)}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      {/* // 1-Show order details */}

      <div>
        <m.h2
          className="TNumber  d-flex justify-content-end"
          initial={{ opacity: 0, x: 15 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {document?.orderNumber || "No ID"}
        </m.h2>
        <m.h2
          className="Review-total mb-5"
          initial={{ opacity: 0, x: 15 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          Order details
        </m.h2>
      </div>

      <div className="Product-Card justify-content-center mb-3">
        {document ? (
          document.cart.map((i, index) => {
            return (
              <Card
                bg=""
                text="dark"
                style={{ width: "18rem" }}
                className="mb-2 mx-2 "
                key={index}
              >
                <Card.Header
                  style={{
                    backgroundColor: i.updatedItem ? "#2f5a76" : "",
                    color: i.updatedItem ? "white" : "black",
                  }}
                >
                  Category: {i.CategoryName || "Unknown"}
                </Card.Header>

                <Card.Body>
                  <Card.Title>Title: {i.name} </Card.Title>
                  <Card.Text>quantity: {i.CartTotalQuantity}</Card.Text>
                  <Card.Text>
                    price: {i.Price} x {i.CartTotalQuantity}
                  </Card.Text>
                  <Card.Text>
                    <div
                      className="d-flex justify-content-center"
                      style={{ gap: "8px" }}
                    >
                      {i.spiceLevel && (
                        <div className="d-flex justify-content-center mt-2 mb-2">
                          <div>
                            <span className="option-square selected ">
                              <b> </b> {i.spiceLevel}
                            </span>
                          </div>
                        </div>
                      )}

                      {i.combo && i.combo.name && (
                        <div className="d-flex justify-content-center mt-2 mb-2">
                          <span className="option-square selected p-2">
                            {i.combo.name} - {i.combo.Price} EGP
                          </span>
                        </div>
                      )}
                    </div>
                  </Card.Text>
                </Card.Body>
              </Card>
            )
          })
        ) : (
          <h2>no data</h2>
        )}
      </div>
      {document?.Notes && (
        <div className="Notes-Card mb-3">
          <p>
            <strong>Notes:</strong>
          </p>
          <p>{document.Notes}</p>
        </div>
      )}
      <div className="d-flex justify-content-center">
        <button
          className=" btns-Admin"
          style={{ backgroundColor: "red" }}
          onClick={handleShow}
        >
          Delete Order
        </button>
      </div>
      <div className="horizontal-divider"></div>
      {/* // 2- Display User Info */}
      <Form>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm="2">
            Name
          </Form.Label>
          <Col sm="10">
            <Form.Control
              plaintext
              readOnly
              defaultValue={document?.userName}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm="2">
            Total price:
          </Form.Label>
          <Col sm="10">
            <Form.Control
              plaintext
              readOnly
              defaultValue={document?.totalAmount?.toFixed(2)}
            />
          </Col>
        </Form.Group>

        {document?.orderDate ? (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Placed At:
            </Form.Label>
            <Col sm="10">
              <Form.Control
                plaintext
                readOnly
                value={`${document.orderDate}, ${convertTo24HourFormat(
                  document.orderTime
                )}`}
              />
            </Col>
          </Form.Group>
        ) : null}

        {document?.createdAt && (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Confirmed At:{" "}
            </Form.Label>
            <Col sm="10">
              <Form.Control
                plaintext
                readOnly
                value={`${new Date(
                  document.createdAt.seconds * 1000
                ).toLocaleDateString()},${convertTo24HourFormat(
                  document.createdAt
                )}`}
              />
            </Col>
          </Form.Group>
        )}

        {document?.pickedAt && (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Picked-At:
            </Form.Label>
            <Col sm="10">
              <Form.Control
                plaintext
                readOnly
                value={`${new Date(
                  document.pickedAt.seconds * 1000
                ).toLocaleDateString()},${convertTo24HourFormat(
                  document.pickedAt
                )}`}
              />
            </Col>
          </Form.Group>
        )}

        {document?.PickedBy && (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Picked By:
            </Form.Label>
            <Col sm="10">
              <Form.Control plaintext readOnly value={document.PickedBy} />
            </Col>
          </Form.Group>
        )}

        {document?.DeliveredBy && (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Delivered By:
            </Form.Label>
            <Col sm="10">
              <Form.Control plaintext readOnly value={document.DeliveredBy} />
            </Col>
          </Form.Group>
        )}

        {document?.deliveredAt && (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Delivered-At:
            </Form.Label>
            <Col sm="10">
              <Form.Control
                plaintext
                readOnly
                value={`${new Date(
                  document.deliveredAt.seconds * 1000
                ).toLocaleDateString()},${convertTo24HourFormat(
                  document.deliveredAt
                )}`}
              />
            </Col>
          </Form.Group>
        )}

        {document?.assignedDriver && (
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              Driver:
            </Form.Label>
            <Col sm="10">
              <Form.Control
                plaintext
                readOnly
                value={document.assignedDriver}
              />
            </Col>
          </Form.Group>
        )}
      </Form>
    </m.div>
  )
}
